module.exports = __webpack_public_path__ + "static/media/28-6.5ed2918f.mp3";